import { uniqBy } from "lodash-es";
import { CalculationResult, FilterItem, Selection } from "src/types";

export function byScenario(results: CalculationResult[], selection: Selection) {
  return results.filter((item) => {
    return item.scenarioId.toString() === selection.scenario;
  });
}

export function bySubstance(results: CalculationResult[], selection: Selection) {
  return results.filter((item) => {
    return item.substanceId.toString() === selection.substance;
  });
}

export function getScenarios(results: CalculationResult[]): FilterItem[] {
  const uniqueByScenario = uniqBy(results, "scenarioId");
  return uniqueByScenario.map((item) => {
    return {
      id: item.scenarioId,
      name: item.scenarioName,
    };
  });
}

export function getSubstances(results: CalculationResult[], selection: Selection): FilterItem[] {
  const resultsForScenario = byScenario(results, selection);
  const uniqueBySubstance = uniqBy(resultsForScenario, "substanceId");

  return uniqueBySubstance.map((item) => {
    return {
      id: item.substanceId,
      name: item.substanceName,
    };
  });
}

export function getCalculations(results: CalculationResult[], selection: Selection): FilterItem[] {
  const resultsForScenario = byScenario(results, selection);
  const resultsForSubstance = bySubstance(resultsForScenario, selection);
  const uniqueByCalculation = uniqBy(resultsForSubstance, "mapType");

  return uniqueByCalculation.map((item) => {
    return {
      id: item.mapTypeKey,
      name: item.mapType,
    };
  });
}

export function validateSubstanceSelection(results: CalculationResult[], selection: Selection) {
  const substances = getSubstances(results, selection);

  if (!substances.find((item) => item.id.toString() === selection.substance)) {
    return {
      ...selection,
      substance: substances[0].id,
    };
  }
  return selection;
}

export function validateCalculationSelection(results: CalculationResult[], selection: Selection) {
  const calculations = getCalculations(results, selection);

  const result = calculations.find((item) => item.id.toString() === selection.calculation);
  if (!result) {
    return {
      ...selection,
      calculation: calculations[0].id,
    };
  }
  return selection;
}
